import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    language
  } = useLanguage();
  const strings = ui[language];
  const links = [{
    to: '/',
    label: strings.nav.cv
  }, {
    to: '/portfolio',
    label: strings.nav.portfolio
  }];
  return <header className="sticky top-0 z-30 border-b border-blush-300/70 bg-blush-100/90 backdrop-blur" data-id="element-49" data-mp="qxys4z1tqb6w">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8" data-id="element-50" data-mp="14xzuyk1nfsp0">
        <Link to="/" className="flex items-baseline gap-2" onClick={() => setOpen(false)} data-id="element-51" data-mp="zwkbgwf4du8q">
          <span className="font-script text-3xl leading-none text-ink" data-id="element-52" data-mp="2gaaf622bughu">Fauve</span>
          <span className="text-sm font-semibold uppercase tracking-[0.25em] text-ink" data-id="element-53" data-mp="2bda75llx33o3">
            Willems
          </span>
        </Link>

        <div className="hidden items-center gap-8 sm:flex" data-id="element-54" data-mp="29jk8t4nluhfo">
          <nav aria-label={strings.nav.portfolio} className="flex items-center gap-8" data-id="element-55" data-mp="2ei3ur5277t81">
            {links.map(link => <NavLink key={link.to} to={link.to} className={({
            isActive
          }) => `text-xs font-semibold uppercase tracking-[0.2em] transition-colors ${isActive ? 'text-ink' : 'text-ink/50 hover:text-ink'}`} data-id="element-56" data-mp="2jij7pvikiyph">
                {link.label}
              </NavLink>)}
            <a href="#contact" className="rounded-full bg-ink px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-blush-50 transition-colors hover:bg-ink/80" data-id="element-57" data-mp="20q77pffe09ii">
              {strings.nav.contact}
            </a>
          </nav>
          <LanguageSwitcher data-id="element-58" data-mp="1d0ml8mk0yu4h" />
        </div>

        <div className="flex items-center gap-2 sm:hidden" data-id="element-59" data-mp="151876jgmjm2v">
          <LanguageSwitcher data-id="element-60" data-mp="14znbgqikpx3f" />
          <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? strings.menuClose : strings.menuOpen} className="rounded-full border border-ink/20 p-2 text-ink" data-id="element-61" data-mp="14yvf3dh5jvc3">
            {open ? <XIcon className="h-5 w-5" data-id="element-62" data-mp="19u19z1sj8kcb" /> : <MenuIcon className="h-5 w-5" data-id="element-63" data-mp="m243lq7uqkil" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label={strings.nav.cv} className="border-t border-blush-300/70 bg-blush-100 px-5 py-4 sm:hidden" data-id="element-64" data-mp="h3soazysfhsz">
          <ul className="flex flex-col gap-3" data-id="element-65" data-mp="w1uxbpol8vhm">
            {links.map(link => <li key={link.to} data-id="element-66" data-mp="qzvqu6xjxigg">
                <NavLink to={link.to} onClick={() => setOpen(false)} className={({
            isActive
          }) => `block text-sm font-semibold uppercase tracking-[0.2em] ${isActive ? 'text-ink' : 'text-ink/60'}`} data-id="element-67" data-mp="r3tbiwzs2i2g">
                  {link.label}
                </NavLink>
              </li>)}
            <li data-id="element-68" data-mp="2108b9f8chzei">
              <a href="#contact" onClick={() => setOpen(false)} className="block text-sm font-semibold uppercase tracking-[0.2em] text-ink/60" data-id="element-69" data-mp="210rq2n2p87ob">
                {strings.nav.contact}
              </a>
            </li>
          </ul>
        </nav>}
    </header>;
}